async function devtricker_process_initializeAllHovercards() {

    try {
        let elements = document.querySelectorAll('.hovercard');

        const loggedUser = devtricker_getTheLoggedUserId();
        if (loggedUser) {

            const authorIds = Array.from(elements)
                .map(el => el.getAttribute('data-author-id'))
                .filter(id => id !== null);

            const knownIds = new Set(devtricker_session_getAllKnownUserIds());
            const unknownIds = authorIds.filter(id => !knownIds.has(id));

            if (unknownIds.length > 0) {

                const follow = await devtricker_ajax_checkIfFollowing(unknownIds);

                Object.entries(follow).forEach(([userId, isFollowing]) => {
                    if (isFollowing) {
                        devtricker_session_followUser(userId);
                    } else {
                        devtricker_session_unfollowUser(userId);
                    }
                });
            }
        }

        if (elements) {
            for (let element of elements) {
                devtricker_process_initializeHovercard(element);
            }
        }

        devtricker_log(null, devtricker_log_level.INFO, `Initialized hovercards. Counter: ${elements.length}`);

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_process_initializeHovercard(element) {

    let authorId = element.getAttribute('data-author-id');
    let isRecent = devtricker_session_isFollowingRecent(authorId) || false;
    let isFollowing = devtricker_session_isFollowing(authorId) || false;
    let newBooleanFollowAction = !isFollowing;
    let authorUrl = element.href;
    let name = element.getAttribute('data-author-name');
    let handle = element.getAttribute('data-author-handle');
    let authorBio = element.getAttribute('data-author-bio');
    let followingCounter = element.getAttribute('data-following-counter');
    let followerCounter = element.getAttribute('data-follower-counter');
    let gravatarUrl = element.getAttribute('data-gravatar-url');

    let popoverInstance = new bootstrap.Popover(element, {
        container: 'body',
        trigger: 'manual',
        html: true,
        animation: true,
        sanitize: false,
        placement: 'bottom',
        content: await devtricker_popoverHtmlContent(name, authorUrl, handle, authorId, newBooleanFollowAction, authorBio, followingCounter, followerCounter, gravatarUrl, element.id, isRecent)
    });

    let showTimeout;
    let closeTimeout;

    function clearShowTimeout() {
        clearTimeout(showTimeout);
    }

    function clearCloseTimeout() {
        clearTimeout(closeTimeout);
    }

    function scheduleShowPopover() {
        showTimeout = setTimeout(() => {
            popoverInstance.show();
        }, 200);
    }

    function scheduleClosePopover() {
        closeTimeout = setTimeout(() => {
            popoverInstance.hide();
        }, 200);
    }

    element.addEventListener('mouseenter', function () {
        clearCloseTimeout();
        scheduleShowPopover();
    });

    element.addEventListener('mouseleave', function () {
        clearShowTimeout();
        scheduleClosePopover();
    });

    element.addEventListener('shown.bs.popover', function () {
        const popoverId = element.getAttribute('aria-describedby');
        const popoverElement = document.getElementById(popoverId);
        popoverElement.style.opacity = '1';
        if (popoverElement) {

            popoverElement.addEventListener('mouseenter', () => {
                clearCloseTimeout();
                clearShowTimeout();
            });

            popoverElement.addEventListener('mouseleave', scheduleClosePopover);
        }
    });

    element.classList.add('hovercard-initialized');
}


async function devtricker_popoverHtmlContent(name, url, handle, userId, isToFollow, bio, followingCounter, followerCounter, gravatarUrl, commentId, isRecent) {

    if (isRecent) {
        if (!isToFollow) {
            followerCounter++;
        }
    }

    let followText = isToFollow ? g_devtricker_i18n.follow : 'Following';
    let currentUser = devtricker_getTheLoggedUserId();

    let button = currentUser == userId ? `` : `<a type='button' class=' btn popover-follow-author rounded-pill fw-semibold follow-background-color' data-author-id='${userId}' onclick='devtricker_followUser(event, this, ${isToFollow})' >${followText}</a>`;

    return `        
        <div class="d-flex flex-row justify-content-between align-items-center">
            <img class="popover-image" src='${gravatarUrl}' alt='${name}' width='4rem' height='4rem'>
            ${button}
        </div>
        <div class="d-flex text-wrap text-truncate">
            <span class='popover-author '><strong>${name}</strong></span>
        </div>
        <span class='popover-author-username fw-semibold text-body-secondary'>${handle}</span>
        <br>
        <p>${bio}</p>
        <br>
        <div class="d-flex flex-row justify-content-between ">
            <span><strong class='following-counter'>${devtricker_formatLargeNumber(followingCounter)}</strong> Following</span>
            <span><strong class='followers-counter'>${devtricker_formatLargeNumber(followerCounter)}</strong> Followers</span>
        </div>
        `;
}

async function devtricker_process_refreshHovercardByUser(userIdToRefresh, followAction) {

    try {
        let isRecent = true;
        const newfollowAction = !followAction;

        let elements = document.querySelectorAll(`.hovercard[data-author-id="${userIdToRefresh}"]`);

        for (let element of elements) {

            let authorUrl = element.href;
            let name = element.getAttribute('data-author-name');
            let handle = element.getAttribute('data-author-handle');
            let authorBio = element.getAttribute('data-author-bio');
            let followingCounter = element.getAttribute('data-following-counter');
            let followerCounter = element.getAttribute('data-follower-counter');
            let gravatarUrl = element.getAttribute('data-gravatar-url');

            const popoverInstance = bootstrap.Popover.getOrCreateInstance(element);

            let isActive = isHovercardActive(element);
            const popoverBody = await devtricker_popoverHtmlContent(name, authorUrl, handle, userIdToRefresh, newfollowAction, authorBio, followingCounter, followerCounter, gravatarUrl, element.id, isRecent);

            if (isActive) {

                await devtricker_process_updateActiveHovercardFollowerCounter(popoverInstance, userIdToRefresh);

                element.addEventListener('hidden.bs.popover', async () => {
                    popoverInstance.setContent({
                        '.popover-body': popoverBody
                    });
                }, { once: true });



            } else {
                popoverInstance.setContent({
                    '.popover-body': popoverBody
                });
            }
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when try increment the follower counter in the active hovercard.');
    }
}

function isHovercardActive(hovercardElement) {
    return hovercardElement && hovercardElement.hasAttribute('aria-describedby');
}

async function devtricker_process_updateActiveHovercardFollowerCounter(popover, userId) {
    let isFollow = devtricker_session_isFollowing(userId);

    if (isFollow) {
        devtricker_process_incrementHovercardFollowerCounter(popover.tip);
    } else {
        devtricker_process_decrementHovercardFollowerCounter(popover.tip);
    }
}


async function devtricker_process_incrementHovercardFollowerCounter(popover) {
    try {

        let followingCounterSpan = popover.querySelector('.followers-counter');

        if (!/[a-zA-Z]/.test(followingCounterSpan.textContent)) {

            let followerCounter = parseInt(followingCounterSpan.textContent.trim()) || 0;

            if (followerCounter < 999) {
                followingCounterSpan.textContent = ` ${++followerCounter} `;
                devtricker_log(null, devtricker_log_level.INFO, 'Current active hovercard follower counter incremented. Counter: ' + followerCounter);
            } else if (followerCounter === 999) {
                followingCounterSpan.textContent = ' 1k ';
                devtricker_log(null, devtricker_log_level.INFO, 'Current active hovercard follower counter incremented. Received 1k. Counter: ' + followerCounter);
            } else {
                devtricker_log(null, devtricker_log_level.INFO, 'Current active hovercard follower counter increment IGNORED. Counter: ' + followerCounter);
            }
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when try increment the follower counter in the active hovercard.');
        throw error;
    }
}

function devtricker_process_decrementHovercardFollowerCounter(popover) {
    try {
        let followingCounterSpan = popover.querySelector('.followers-counter');

        if (followingCounterSpan && !isNaN(parseInt(followingCounterSpan.textContent))) {

            if (!/[a-zA-Z]/.test(followingCounterSpan.textContent)) {

                let followerCounter = parseInt(followingCounterSpan.textContent.trim()) || 0;

                if (followerCounter > 0 && followerCounter <= 999) {
                    followingCounterSpan.textContent = ` ${--followerCounter} `;
                    devtricker_log(null, devtricker_log_level.INFO, 'Current active hovercard follower counter decremented. Counter: ' + followerCounter);
                } else {
                    devtricker_log(null, devtricker_log_level.INFO, 'Current active hovercard follower counter decrement IGNORED. Counter: ' + followerCounter);
                }
            }
        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when try decrement the follower counter in the active hovercard.');
        throw error;
    }
}